/**
 * @generated SignedSource<<1d6b383ce031d94190956de7ae8576ac>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime'
export type dependenciesQuery$variables = {
  ids?: ReadonlyArray<number> | null
  size?: number | null
}
export type dependenciesQuery$data = {
  readonly listMapItems: {
    readonly items: ReadonlyArray<{
      readonly cemeteryId: number
      readonly location: {
        readonly lat: number
        readonly lng: number
      }
    }>
  }
}
export type dependenciesQuery = {
  variables: dependenciesQuery$variables
  response: dependenciesQuery$data
}

const node: ConcreteRequest = (function () {
  var v0 = [
      {
        defaultValue: null,
        kind: 'LocalArgument',
        name: 'ids'
      },
      {
        defaultValue: 500,
        kind: 'LocalArgument',
        name: 'size'
      }
    ],
    v1 = [
      {
        alias: 'listMapItems',
        args: [
          {
            fields: [
              {
                kind: 'Variable',
                name: 'ids',
                variableName: 'ids'
              }
            ],
            kind: 'ObjectValue',
            name: 'filter'
          },
          {
            fields: [
              {
                kind: 'Literal',
                name: 'from',
                value: 0
              },
              {
                kind: 'Variable',
                name: 'size',
                variableName: 'size'
              }
            ],
            kind: 'ObjectValue',
            name: 'page'
          }
        ],
        concreteType: 'CemeteryResult',
        kind: 'LinkedField',
        name: 'listCemeteries',
        plural: false,
        selections: [
          {
            alias: null,
            args: null,
            concreteType: 'Cemetery',
            kind: 'LinkedField',
            name: 'items',
            plural: true,
            selections: [
              {
                alias: 'cemeteryId',
                args: null,
                kind: 'ScalarField',
                name: 'id',
                storageKey: null
              },
              {
                alias: null,
                args: null,
                concreteType: 'Location',
                kind: 'LinkedField',
                name: 'location',
                plural: false,
                selections: [
                  {
                    alias: null,
                    args: null,
                    kind: 'ScalarField',
                    name: 'lat',
                    storageKey: null
                  },
                  {
                    alias: 'lng',
                    args: null,
                    kind: 'ScalarField',
                    name: 'lon',
                    storageKey: null
                  }
                ],
                storageKey: null
              }
            ],
            storageKey: null
          }
        ],
        storageKey: null
      }
    ]
  return {
    fragment: {
      argumentDefinitions: v0 /*: any*/,
      kind: 'Fragment',
      metadata: null,
      name: 'dependenciesQuery',
      selections: v1 /*: any*/,
      type: 'Query',
      abstractKey: null
    },
    kind: 'Request',
    operation: {
      argumentDefinitions: v0 /*: any*/,
      kind: 'Operation',
      name: 'dependenciesQuery',
      selections: v1 /*: any*/
    },
    params: {
      cacheID: 'cbf1a6a0b0b584dc34002e20bb112402',
      id: null,
      metadata: {},
      name: 'dependenciesQuery',
      operationKind: 'query',
      text: 'query dependenciesQuery(\n  $ids: [Int!]\n  $size: Int = 500\n) {\n  listMapItems: listCemeteries(filter: {ids: $ids}, page: {from: 0, size: $size}) {\n    items {\n      cemeteryId: id\n      location {\n        lat\n        lng: lon\n      }\n    }\n  }\n}\n'
    }
  }
})()

;(node as any).hash = '894bc523bcf479e69f7709dd15c9b631'

export default node
